module.exports = __webpack_public_path__ + "img/reminders-2.dbf91bfb.gif";